import React from 'react';
import { ClockIcon } from 'lucide-react';
import { ctaHref, offerCountdownHours } from '../data/content';
import { useCountdown } from '../hooks/useCountdown';
const pad = (n: number) => String(n).padStart(2, '0');
export function CountdownBanner() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(offerCountdownHours);
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <a href={ctaHref} className="sticky top-0 z-50 block bg-petrol-deep text-paper transition-colors duration-150 ease-out hover:bg-petrol" aria-label={`La oferta termina en ${hours} horas, ${minutes} minutos y ${seconds} segundos. Ir a la oferta.`} data-id="element-39" data-mp="dg8ujwj32kr">
      <div className="mx-auto flex max-w-content items-center justify-center gap-3 px-4 py-2.5 sm:gap-5" data-id="element-40" data-mp="f3f5gi8fq5y4">
        <span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-terra-soft sm:text-sm" data-id="element-41" data-mp="k16wzb563q1s">
          <ClockIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-42" data-mp="ns32pzo6cx8o" />
          La oferta termina en:
        </span>
        <span className="flex items-center gap-1.5 sm:gap-2" aria-hidden="true" data-id="element-43" data-mp="isqdx9dqtg3g">
          {units.map((u, i) => <React.Fragment key={u.label} data-id="element-44" data-mp="dv84lhvtcyux" data-mpi={i}>
              {i > 0 && <span className="text-cream/40" data-id="element-45" data-mp="8v3nbpn3003n">:</span>}
              <span className="flex items-baseline gap-1 rounded-md bg-petrol px-2 py-1" data-id="element-46" data-mp="8wdm6h1rdcbc">
                <span className="font-semibold tabular-nums text-paper sm:text-lg" data-id="element-47" data-mp="16hsyoq3obp26">{pad(u.value)}</span>
                <span className="text-[10px] uppercase tracking-wider text-cream/60" data-id="element-48" data-mp="11l2fhtwkodcj">{u.label}</span>
              </span>
            </React.Fragment>)}
        </span>
      </div>
    </a>;
}